import { AppModule } from 'app/module';
import { JobsListItem } from 'module/jobsListItem/main';
import { Base64Link } from 'module/base64Link/main';
import { getJson } from 'util/xhr';
import Template from './template.hbs';
import './styles.scss';

export class JobsListSwitch extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        this.initInitialProps();
    }

    initInitialProps() {
        const slug = this.dom.el.getAttribute('data-slug');

        this.initialProps = {
            beginnerJobs: {
                slug,
                beginnerJobsFilter: true,
                experienceJobsFilter: false,
                jobs: {
                    activeItems: {},
                },
            },
            experienceJobs: {
                slug,
                beginnerJobsFilter: false,
                experienceJobsFilter: true,
                jobs: {
                    activeItems: {},
                },
            },
        };
    }

    domBindings() {
        return {
            jobs: ['.m-jobsListItem'],
            filterBeginnerBtn: '.m-jobsListSwitch__filterBeginner',
            filterExperienceBtn: '.m-jobsListSwitch__filterExperience',
            link: '.m-base64Link',
        };
    }

    domEvents() {
        if (this.dom.filterBeginnerBtn) {
            this.dom.filterBeginnerBtn.addEventListener('click', (e) => this.switchJobList(e, 'beginnerJobs'));
        }
        if (this.dom.filterExperienceBtn) {
            this.dom.filterExperienceBtn.addEventListener('click', (e) => this.switchJobList(e, 'experienceJobs'));
        }
    }

    subs() {
        this.jobsItems = [];
        for (let i = 0; i < this.dom.jobs.length; i += 1) {
            this.jobsItems[i] = new JobsListItem(this.dom.jobs[i]);
        }
        if (this.dom.link) {
            this.link = new Base64Link(this.dom.link);
        }
    }

    subEvents() {
        for (let i = 0; i < this.jobsItems.length; i += 1) {
            this.jobsItems[i].events.on(
                'changedLocation',
                (searchRequest) => this.events.emit('changedLocation', searchRequest.arguments[0]),
            );
        }
    }

    switchJobList(e, type) {
        if (!e.target.classList.contains('.m-jobsListSwitch__filterText--active')) {
            if (!this.initialProps[type].jobs.activeItems.items) {
                this.events.emit('showOverlay');
                if (this.fetch) {
                    return;
                }

                this.fetch = getJson(
                    `/beruf/${this.initialProps[type].slug}/jobs?type=${type}`,
                    {},
                    (response) => this.onResponse(response, type),
                    () => this.onError(),
                );
            } else {
                this.updateProps(this.initialProps[type], true);
            }
        }
    }

    onResponse(response, type) {
        this.events.emit('hideOverlay');
        this.fetch = false;
        this.initialProps[type] = { ...this.initialProps[type], ...response.professionJobs };
        this.updateProps(this.initialProps[type], true);
    }

    onError() {
        this.fetch = false;
        this.updateProps({ error: true }, true);
    }
}
